import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c1-one-four-one-one',
  templateUrl: './c1-one-four-one-one.component.html',
  styleUrls: ['./c1-one-four-one-one.component.scss']
})
export class C1OneFourOneOneComponent implements OnInit {
  pdfSrc: string[] = ['/assets/pdf/NAAC/Criterion 1/1.4.1_Feedback from different stakeholders/1.4.1.1_ANY OTHER DOCUMENT.pdf'];
  src: string;
  constructor() { }

  ngOnInit(): void {
    this.src = this.pdfSrc[0];
  }

}
